import { ReactNode } from 'react';

import styles from './marketplace-card-buy.module.css';

interface MarketplaceCardBuyProps {
  cost: string;
  children?: ReactNode;
}

const MarketplaceCardBuy = ({ cost, children }: MarketplaceCardBuyProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.price}>
        <div className={styles.priceLabel}>
          Стоимость:
        </div>
        <div className={styles.priceValue}>
          {cost}
        </div>
      </div>
      <div className={styles.buttons}>
        {children}
      </div>
    </div>
  );
};

export default MarketplaceCardBuy;
